<template>
  <tr>
    <td>
      <el-form-item
        :error="productError"
        style="margin-top: -3px;"
      >
        <el-tooltip
          placement="top"
          :disabled="!Object.keys(item.product).length"
        >
          <div slot="content">{{ item.product && item.product.name }}</div>
          <el-select
            v-model="item.product"
            style="width: 100%;"
            :loading="productSelectLoading"
            filterable
            remote
            clearable
            :remote-method="fetchProducts"
            value-key="id"
            size="small"
            @change="checkProductValue"
          >
            <el-option
              v-for="prod in products"
              v-show="!isProductSelected(prod.id)"
              :key="prod.id"
              :value="prod"
              :label="prod.name"
            />
          </el-select>
        </el-tooltip>
      </el-form-item>
    </td>
    <td>
      <el-form-item
        style="margin-top: -3px;"
        :error="priceError"
      >
        <el-input-localized-numeric
          v-model="item.price"
          size="small"
          @input="checkPriceValue"
        />
      </el-form-item>
    </td>
    <td
      style="text-align: right; width: 44px"
    >
      <el-button
        type="danger"
        icon="el-icon-delete"
        size="mini"
        @click="$emit('deleteProduct')"
      />
    </td>
  </tr>
</template>

<script>
  export default {
    props: ['priceListItem', 'selectedItems'],
    data() {
      return {
        item: {
          product: {},
          price: null
        },
        products: [],
        productSelectLoading: false,
        priceError: '',
        productError: ''
      }
    },
    mounted() {
      this.item = JSON.parse(JSON.stringify(this.priceListItem));
      this.products.push(this.item.product);
    },
    methods: {
      async fetchProducts(query) {
        if (query !== '') {
          this.productSelectLoading = true;
          this.products = await axios.get('/api/products/name/' + query);
          this.productSelectLoading = false;
        }
      },
      isProductSelected(productId) {
        let product = this.selectedItems.find(item => item.product && item.product.id && item.product.id === productId);
        return !!product;
      },
      checkProductValue() {
        if (!Object.keys(this.item.product).length) {
          this.productError = 'Kötelező mező';
          return false;
        }
        this.productError = '';
        this.$emit('selectedProduct', this.item.product);
        return true;
      },
      checkPriceValue() {
        if(this.item.price === '' || this.item.price === null) {
          this.priceError = 'Mező kitöltésse kötelező';
          return false;
        }
        if ((isNaN(parseFloat(this.item.price)) || (typeof this.item.price === 'string' && !this.item.price.match(/^\d*\.?\d*?$/)))) {
          this.priceError = 'Mező csak szamokat tartalmazhat';
          return false;
        }
        this.priceError = '';
        return true;
      }
    }
  }
</script>
